export const Translate = {
	// '-1/2': '-translate-1/2', // For some reason didn't work
} as const;
